import { useMemo, useState } from "react";
import { matchesQuery } from "../api/format";
import type { Station } from "../api/types";

export function StationPicker({
  stations,
  value,
  onChange,
  label,
}: {
  stations: Station[];
  value: number | null;
  onChange: (id: number | null) => void;
  label: string;
}) {
  const [query, setQuery] = useState("");
  const selected = stations.find((s) => s.station_id === value) ?? null;

  const results = useMemo(() => {
    return stations.filter((s) => matchesQuery(query, s.station_name, s.station_name_ur, s.city, s.station_id)).slice(0, 12);
  }, [stations, query]);

  return (
    <label className="picker">
      <span>{label}</span>
      {selected ? (
        <div className="picker-selected">
          <strong>{selected.station_name}</strong>
          <span className="muted">{selected.city}</span>
          <button type="button" className="linkish" onClick={() => onChange(null)}>
            change
          </button>
        </div>
      ) : (
        <>
          <input
            type="search"
            value={query}
            placeholder="Search station name, city, Urdu…"
            onChange={(e) => setQuery(e.target.value)}
          />
          {query.trim() ? (
            <ul className="picker-list">
              {results.length === 0 ? <li className="muted">No matches</li> : null}
              {results.map((s) => (
                <li key={s.station_id}>
                  <button
                    type="button"
                    onClick={() => {
                      onChange(s.station_id);
                      setQuery("");
                    }}
                  >
                    <strong>{s.station_name}</strong>
                    <span className="muted">
                      {s.city}
                      {s.station_name_ur ? ` · ${s.station_name_ur}` : ""}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : null}
        </>
      )}
    </label>
  );
}
